import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/bancos/cheques';
import ChequesForm from './ChequesFormTabs';


const ms2p = (state) => {
  return {
    ...state.cheques,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(ChequesForm);
